import { Stack } from '@mui/material';
import { styled } from '~/themes';

export const StyledFilterContainer = styled(Stack)(({ theme }) => ({
  'flexDirection': 'row',
  'justifyContent': 'space-between',
  'gap': theme.spacing(1, 2),
  'flexWrap': 'wrap',
  'marginBottom': theme.spacing(2.4),
  '& > form': {
    minWidth: 300,
  },

  [theme.breakpoints.down('md')]: {
    'gap': theme.spacing(1),
    '& > form': {
      minWidth: 0,
      display: 'flex',
      flex: 1,
    },
  },
}));
